import { useUserStore } from '../../../../../../lib-sat/store/modules/user-store';

export default class Conversion {
    target = 'text-to-image';
    category = 'operation';
    options = {
        aspect_ratio: '1:1',
        style: 'photography',
        allow_multiple_outputs: true,
        cfg_scale: 7,
        num_inference_steps: 20,
        batch_size: 2,
        batch_count: 1,
    }

    constructor() {
    }
}
